<template>
	<div id="app">
		<div v-if="maintenance=='true'" class='maintenance'>
			<div class="cotent">
				<icon file="alert-triangle" :size="40" />
            	<span class="label" >Application en maintenance, veuillez nous excuser pour la gêne occasionnée.</span>
			</div>	
		</div>
		<div v-else-if="token_loading" class='loading'>
				<img class="loading-gif" src="./assets/img/loading_ripple_01.gif" alt="chargement..." />
		</div>
		

		<router-view/>
		<viewer />
	<div class="env" :class="env">
      <div>{{ env }}</div>
    </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

import Viewer from '@/components/etude/viewer'

export default {
	data() {
    return {
      env: process.env.VUE_APP_ES_ENV,
	  maintenance: process.env.VUE_APP_MAINTENANCE
    };
  },
	name: 'app',
	mounted: function() {


		// Check each "n" minutes if timeout is triggered (not use in login page)
		let check_activity= parseInt(process.env.VUE_APP_CHECK_ACTIVITY,10) *1000
		 window.setInterval(() => {
			//Check inactivity > 45 min ??
			if(this.$route.name !='login'){
				this.$store.dispatch("check_activity").then(()=>{
					//console.log('this.is_authenticated : ',this.is_authenticated)
					if(!this.is_authenticated){
						//close active study if it's open
						this.$store.dispatch('set_active_pdf', { active_pdf: false })
						this.$router.push({ name: 'login' });	
					}
				})
			}	
		}, check_activity)
	},
	components: { 
		Viewer
	},
	 computed: {
    ...mapGetters(["token_loading","is_authenticated"]),
	}
}
</script>

<style lang="stylus">
@import url('https://fonts.googleapis.com/css?family=Fira+Sans:400,500')
@import './assets/css/app'
@import './assets/css/grid'
@import './assets/css/scrollbar.css'

.maintenance
	margin: auto;
	background-color: white;
	display: flex;
	height: 100%;
	width: 100%;
	position: fixed;
	z-index: 1111;
	opacity: 0.9;
	text-align: center
	font-size: x-large
	padding-top: 32px
	.cotent
		margin: auto
		.label
			padding 8px

.loading
	margin: auto;
	background-color: white;
	display: flex;
	height: 100%;
	width: 100%;
	position: fixed;
	z-index: 1111;
	opacity: 0.9;
	.loading-gif
		margin: auto

:root
	font-size 62.5%

*
	margin 0
	padding 0
	position relative
	box-sizing border-box
	
html, body, #app
	height 100%
	overflow hidden

body
	font-family 'Fira Sans', Arial
	font-size 1.3rem
	line-height 1.2em
	font-weight 400
	color #333
	background-color #fff

a
	font inherit
	color inherit
	text-decoration none
	
strong
	font-weight 500
	
.content
	width 1200px
	margin 0 auto

.scroll-wrap, .scroll, .scroll-content
	height 100%
	
::selection
	background-color red
	color #fff

::-webkit-input-placeholder
	color #bbb
	opacity 1
	font-weight 400
::-moz-placeholder
	color #bbb
	opacity 1
	font-weight 400
:-ms-input-placeholder
	color #bbb
	opacity 1
	font-weight 400
:-moz-placeholder
	color #bbb
	opacity 1
	font-weight 400

@keyframes rotate
	from
		transform rotate(0deg)
	to
		transform rotate(359deg)

.env {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgb(255, 255, 255);
  height: 96px;
  width: 96px;
  border-radius: 50%;

  position: absolute;
  left: 8px;
  bottom: 8px;
  z-index: 1000;
}	
.DEV {
  background-color: black;
//   opacity: 0.8;
  color : white ;
  border-style : solid;
  border-width : 2px ;
  border-color : black;
  font-size : 14px ;
  font-weight :500;
}

.PROD {
  background-color: rgb(255, 255, 255);
  visibility: hidden;
}
</style>
